// This file is generated by a script. Do not edit this file directly.
var _excluded = ["label", "description", "tooltipProps", "checked", "onChange", "disabled", "size", "classes"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { cn } from "../../common/utils";
import { Base } from "../Typography/Base";
import { Icon } from "../Icon";
import { cva } from 'cva';
import { useRadioGroup } from "../RadioGroup/RadioGroup";
import { Tooltip } from "../Tooltip/Tooltip";
export var RadioSize = /*#__PURE__*/function (RadioSize) {
  RadioSize["DEFAULT"] = "default";
  RadioSize["LARGE"] = "lg";
  return RadioSize;
}({});
var radioContainerStyles = cva({
  base: 'cop-cursor-pointer cop-group cop-box-border cop-flex cop-items-center cop-justify-center cop-rounded-full cop-border cop-border-solid cop-outline-none peer-focus-visible:cop-outline-2 peer-focus-visible:cop-outline-[#0071E3]',
  variants: {
    size: _defineProperty(_defineProperty({}, RadioSize.DEFAULT, 'cop-h-4 cop-w-4'), RadioSize.LARGE, 'cop-h-[18px] cop-w-[18px]'),
    checked: {
      "true": 'cop-border-primary hover:cop-border-[#36424D]',
      "false": 'cop-border-gray-300 hover:cop-bg-[#F8F9FB]'
    },
    disabled: {
      "true": 'cop-pointer-events-none cop-cursor-default cop-bg-secondary cop-text-[#90959D]',
      "false": ''
    }
  },
  compoundVariants: [{
    checked: true,
    disabled: true,
    className: '!cop-border-secondary'
  }],
  defaultVariants: {
    size: RadioSize.DEFAULT,
    checked: false,
    disabled: false
  }
});
var radioIconStyles = cva({
  variants: {
    size: _defineProperty(_defineProperty({}, RadioSize.DEFAULT, 'cop-h-2 cop-w-2'), RadioSize.LARGE, 'cop-h-[10px] cop-w-[10px]'),
    checked: {
      "true": 'cop-text-primary group-hover:cop-text-[#36424D]',
      "false": ''
    },
    disabled: {
      "true": 'cop-text-input-gray',
      "false": ''
    }
  },
  compoundVariants: [{
    checked: true,
    disabled: true,
    className: '!cop-text-input-gray'
  }]
});
export var Radio = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
    description = props.description,
    tooltipProps = props.tooltipProps,
    controlledChecked = props.checked,
    controlledOnChange = props.onChange,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$size = props.size,
    size = _props$size === void 0 ? RadioSize.DEFAULT : _props$size,
    classes = props.classes,
    rest = _objectWithoutProperties(props, _excluded);
  var groupContext = useRadioGroup();

  // Determine if the radio is part of a group
  var isPartOfGroup = !!groupContext;

  // Use context values if part of a group, otherwise rely on props
  var checked = isPartOfGroup ? (groupContext === null || groupContext === void 0 ? void 0 : groupContext.value) === rest.value : controlledChecked;
  var handleChange = function handleChange(event) {
    if (isPartOfGroup && groupContext !== null && groupContext !== void 0 && groupContext.onChange) {
      groupContext.onChange(event);
    } else if (controlledOnChange) {
      controlledOnChange(event);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes === null || classes === void 0 ? void 0 : classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-gap-2"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: rest.name
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: rest.name,
    className: "cop-peer cop-sr-only cop-fixed",
    ref: ref,
    type: "radio",
    checked: checked,
    onChange: handleChange,
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement("div", {
    className: cn(radioContainerStyles({
      size: size,
      checked: checked,
      disabled: disabled
    }), classes === null || classes === void 0 ? void 0 : classes.input)
  }, checked && /*#__PURE__*/React.createElement(Icon, {
    icon: "Dot",
    className: radioIconStyles({
      size: size,
      checked: checked,
      disabled: disabled
    })
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-gap-1"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "base",
    leading: "tight",
    tag: "span",
    weight: "medium"
  }, label), tooltipProps && /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement(Icon, {
    icon: "Info",
    className: "cop-h-3 cop-w-3 cop-text-primary"
  }))), description && /*#__PURE__*/React.createElement("div", {
    className: "cop-mt-0.5 cop-text-secondary"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "sm",
    leading: "normal",
    tag: "span",
    weight: "regular"
  }, description)))));
});
Radio.displayName = 'Radio';
